export default __webpack_public_path__ + "static/almendral-alpujarra-07a3a24bbac8e236ca24003666ef6b67.jpg";